import User from '../models/User'

const isAdmin = (user: User) => user && user.roles.some(r => r.name === 'admin')

export default isAdmin
